export const LIST_ITEM_COPY = {
  NO_POLICY: 'No Policy',
  NO_FRAMEWORK: 'No Framework',
  NOT_APPLICABLE_POLICY: 'N/A Policy',
}
